import { BASE_HANDLER_URL } from ".";
import {
  DEFAULT_GRID_INFO_TICKET,
  DEFAULT_GRID_INFO_TASK,
} from "../Components/Tickets/KendoTicketGrid";

export const loadTicketTaskGridData = async (
  filterData,
  gridState,
  sharedData
) => {
  document.getElementById("loader").style.display = "block";
  let currentPage;
  let currentSize;
  let currentSortName;
  let currentSortOrder;
  let className;
  let action;

  currentPage =
    gridState.pageNumber ?? filterData.type === "Ticket"
      ? DEFAULT_GRID_INFO_TICKET.currentPageNumber
      : DEFAULT_GRID_INFO_TASK.currentPageNumber;

  currentSize =
    gridState.pageSize ?? filterData.type === "Ticket"
      ? DEFAULT_GRID_INFO_TICKET.pageSize
      : DEFAULT_GRID_INFO_TASK.pageSize;

  currentSortName = gridState.sort[0].field;

  // currentSortName =
  //   gridState.sort[0].field ?? filterData.type === "Ticket"
  //     ? DEFAULT_GRID_INFO_TICKET.sortName
  //     : DEFAULT_GRID_INFO_TASK.sortName;

  currentSortOrder = gridState.sort[0].dir;

  // currentSortOrder =
  //   gridState.sort[0].dir ?? filterData.type === "Ticket"
  //     ? DEFAULT_GRID_INFO_TICKET.sortOrder
  //     : DEFAULT_GRID_INFO_TASK.sortOrder;

  className =
    filterData.type === "Ticket"
      ? DEFAULT_GRID_INFO_TICKET.className
      : DEFAULT_GRID_INFO_TASK.className;

  action =
    filterData.type === "Ticket"
      ? DEFAULT_GRID_INFO_TICKET.action
      : DEFAULT_GRID_INFO_TASK.action;

  // sharedData.quickSearch ? 1 : filterData.currentPage

  try {
    const formData = new FormData();
    formData.append("page", filterData.currentPage);
    formData.append("rp", currentSize);
    formData.append("sortname", currentSortName);
    formData.append("sortorder", currentSortOrder);
    formData.append("query", "");
    formData.append("qtype", "");
    let queryParams = null;

    if (sharedData.quickSearch) {
      queryParams = new URLSearchParams({
        txtQuickSearch: sharedData.quickData,
        userType: sessionStorage.type,
        CP: sessionStorage.CP,
        APPUSER: sessionStorage.USER,
        Reseller: sessionStorage.Reseller,
      }).toString();
      action = "QUICKSEARCHTICKETS";
      className = "DASHBOARD";
    } else if (filterData.type === "A" || filterData.type === "Task") {
      queryParams = new URLSearchParams({
        Type: filterData.type ? filterData.type.trim() : "",
        TXTALLKEYWORDS: filterData.keyword ? filterData.keyword.trim() : "",
        Reporter: filterData.reporter ? filterData.reporter.trim() : "",
        Status: filterData.status ? filterData.status.trim() : "", // check upper 12
        TXTALLASSIGNEE: filterData.assignee ? filterData.assignee.trim() : "", // also cleaer this point 16
        TXTPRACTICENAME: filterData.practiceName
          ? filterData.practiceName.trim()
          : "",
        ticketCategory: filterData.ticketCategory
          ? filterData.ticketCategory.trim()
          : "",
        TXTALLPRIORITY: filterData.priority ? filterData.priority.trim() : "",
        teamCategory: filterData.teamCategory
          ? filterData.teamCategory.trim()
          : "",
        followDays: filterData.followDays ? filterData.followDays.trim() : "",
        priorityClients: filterData.priorityClient
          ? filterData.priorityClient.trim()
          : "",
        StatusDays: filterData.statusDays ? filterData.statusDays.trim() : "",
        txtInternalAssignee: filterData.internalAssignee
          ? filterData.internalAssignee.trim()
          : "",
        suspended: filterData.suspended ? filterData.suspended.trim() : "",
        CustAccNum: filterData.customerId ? filterData.customerId.trim() : "", // also clear this now 15
        client: filterData.clientId ? filterData.clientId.trim() : "",
        FromDate: filterData.fromDate ? filterData.fromDate.trim() : "",
        ToDate: filterData.toDate ? filterData.toDate.trim() : "",
        TargetDate: filterData.targetDate ? filterData.targetDate.trim() : "",
        overDue: filterData.overDue ? filterData.overDue.trim() : "",
        ddlTeam: filterData.team ? filterData.team : "",
        userType: sessionStorage.type ?? "",
        CP: sessionStorage.CP ?? "",
        APPUSER: sessionStorage.USER ?? "",
        Reseller: sessionStorage.Reseller ?? "",
        entitySeqNum: filterData.entityId ?? "",
      }).toString();
    } else {
      queryParams = new URLSearchParams({
        Type: filterData.type ? filterData.type.trim() : "",
        TXTALLKEYWORDS: filterData.keyword ? filterData.keyword.trim() : "",
        Reporter: filterData.reporter ? filterData.reporter.trim() : "",
        TXTALLSTATUS: filterData.status ? filterData.status.trim() : "",
        TXTALLASSIGNEE: filterData.assignee ? filterData.assignee.trim() : "",
        TXTPRACTICENAME: filterData.practiceName
          ? filterData.practiceName.trim()
          : "",
        ticketCategory: filterData.ticketCategory
          ? filterData.ticketCategory.trim()
          : "",
        TXTALLPRIORITY: filterData.priority ? filterData.priority.trim() : "",
        teamCategory: filterData.teamCategory
          ? filterData.teamCategory.trim()
          : "",
        followDays: filterData.followDays ? filterData.followDays.trim() : "",
        priorityClients: filterData.priorityClient
          ? filterData.priorityClient.trim()
          : "",
        StatusDays: filterData.statusDays ? filterData.statusDays.trim() : "",
        txtAllInternalAssignee: filterData.internalAssignee
          ? filterData.internalAssignee.trim()
          : "",
        suspended: filterData.suspended ? filterData.suspended.trim() : "",
        CustAccNum: filterData.customerId
          ? String(filterData?.customerId ?? "").trim()
          : "",
        client: filterData.clientId
          ? String(filterData?.clientId ?? "").trim()
          : "",
        FromDate: filterData.fromDate ? filterData.fromDate.trim() : "",
        ToDate: filterData.toDate ? filterData.toDate.trim() : "",
        TargetDate: filterData.targetDate ? filterData.targetDate.trim() : "",
        overDue: filterData.overDue ? filterData.overDue.trim() : "",
        ddlDteam: filterData.team ? filterData.team.trim() : "",

        userType: sessionStorage.type ? sessionStorage.type.trim() : "",
        CP: sessionStorage.CP ? sessionStorage.CP.trim() : "",
        APPUSER: sessionStorage.USER ? sessionStorage.USER.trim() : "",
        Reseller: sessionStorage.Reseller ? sessionStorage.Reseller.trim() : "",
      }).toString();
    }

    const url = `${BASE_HANDLER_URL}?class=${className}&action=${action}&${
      queryParams ? `${queryParams}` : ""
    }`;
    const result = await fetch(url, {
      method: "POST",
      body: formData,
    });

    const response = await result.json();

    document.getElementById("loader").style.display = "none";
    return response;

    // if (response?.status === true) {
    //   document.getElementById("loader").style.display = "none";
    //   return response;
    // } else  (
    //   response?.status === false &&
    //   response?.Message ===
    //     "Collection was modified; enumeration operation may not execute."
    // )
  } catch (error) {
    console.error("Error fetching data:", error);
  }
  document.getElementById("loader").style.display = "none";
};
